import { render } from "./ViewPDFButton.vue?vue&type=template&id=8213128c"
import script from "./ViewPDFButton.vue?vue&type=script&lang=js"
export * from "./ViewPDFButton.vue?vue&type=script&lang=js"

import "./ViewPDFButton.vue?vue&type=style&index=0&id=8213128c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__